import { type RootState } from '@reducers';
import { Button, Slider, Space, Typography } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { categorySetEndPriceMarginRate } from '../../reducers/category/reducer';
import AsyncFeedback from '../async-feedback';

const { Title } = Typography;

function PricesComponent(): React.ReactElement {
  const dispatch = useAppDispatch();
  const categoryEndPriceMarginRate = useSelector(
    (s: RootState) => s.Category.category?.endPriceMarginRate,
  );
  const categoryInProcess = useSelector((s: RootState) => s.Category.inProcess);
  const categoryUpdatedAt = useSelector((s: RootState) => s.Category.updatedAt);
  const categoryUUID = useSelector((s: RootState) => s.Category.category?.uuid);

  const [
    categoryEndPriceMarginRateSlider,
    setCategoryEndPriceMarginRateSlider,
  ] = useState<number>(categoryEndPriceMarginRate || 1);

  return (
    <Space orientation="vertical" style={{ width: '100%' }}>
      <Title level={5}>Product end price margin rate</Title>
      <Slider
        min={0.5}
        max={2}
        step={0.005}
        marks={{
          0.5: '50%',
          1: '100%',
          1.5: '150%',
          2: '200%',
        }}
        tooltip={{
          formatter: (value: number): string =>
            `${Math.floor(value * 1000) / 10}%`,
        }}
        defaultValue={categoryEndPriceMarginRateSlider}
        disabled={categoryInProcess}
        onChange={(value: number): void => {
          setCategoryEndPriceMarginRateSlider(value);
        }}
      />

      <Button
        type="primary"
        disabled={categoryInProcess}
        loading={categoryInProcess}
        block
        onClick={(): void => {
          if (!categoryUUID) {
            return;
          }

          dispatch(
            categorySetEndPriceMarginRate(
              categoryUUID,
              categoryEndPriceMarginRateSlider,
            ),
          );
        }}
      >
        Submit
      </Button>
      <AsyncFeedback
        inProcess={categoryInProcess}
        updatedAt={categoryUpdatedAt}
      />
    </Space>
  );
}

export default PricesComponent;
